import React from "react";
import styles from "@fyendalscollection/marketing/lib/components/FrameTextual.module.scss";
import icon from "@fyendalscollection/marketing/assets/icon.svg";
import { Outlet } from "react-router-dom";

export const FrameTextual = (): JSX.Element => {
	return (
		<div className={styles.frameTextual}>
			<div className={styles.title}>
				<img src={icon} />
				<div className={styles.text}>Fyendal&apos;s Collection</div>
			</div>

			<Outlet />
		</div>
	);
};
